module.exports = __webpack_public_path__ + "static/wiczlino3-76743c8b3e1d41126915012a7592e8eb.jpg";